import ContentCard from '@/components/ui/Cards/ContentCard';
import type { GenericContentCardBlock as GenericContentCardBlockProps } from '@/@types/content';

const GenericContentCardBlock: React.FC<GenericContentCardBlockProps> = props => (
  <ContentCard {...props} />
);

export default GenericContentCardBlock;
